import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのUserAccountsロゴアイコン
 */
export function ProductLogoSmallUserAccounts({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M4.5625 16C4.5625 14.067 6.1295 12.5 8.0625 12.5H12.0625C13.9955 12.5 15.5625 14.067 15.5625 16H4.5625Z"
        fill={color}
      />
      <path d="M6.0625 17.5H14.0625V16H6.0625V17.5Z" fill={color} />
      <path
        d="M13.0625 8.5C13.0625 10.1569 11.7194 11.5 10.0625 11.5C8.40565 11.5 7.0625 10.1569 7.0625 8.5C7.0625 6.84315 8.40565 5.5 10.0625 5.5C11.7194 5.5 13.0625 6.84315 13.0625 8.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0625 17C13.9285 17 17.0625 13.866 17.0625 10C17.0625 6.13401 13.9285 3 10.0625 3C6.19651 3 3.0625 6.13401 3.0625 10C3.0625 13.866 6.19651 17 10.0625 17ZM10.0625 18.5C14.7569 18.5 18.5625 14.6944 18.5625 10C18.5625 5.30558 14.7569 1.5 10.0625 1.5C5.36808 1.5 1.5625 5.30558 1.5625 10C1.5625 14.6944 5.36808 18.5 10.0625 18.5Z"
        fill={color}
      />
    </svg>
  );
}
